window.onscroll = function() {alwaysTop()};

var header = document.getElementById("myHeader");
var sticky = header.offsetTop;

function alwaysTop() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

$('.navbar-toggler').on("click",function(){
  if($('#navbarsSyx').hasClass('collapse')){
    $('#navbarsSyx').removeClass('collapse');
  } else{
    $('#navbarsSyx').addClass('collapse');
  }
});

	var fullHeight = function() {

		$('.js-fullheight').css('height', $(window).height());
		$(window).resize(function(){
			$('.js-fullheight').css('height', $(window).height());
		});

	};
	fullHeight();

	// loader
	var loader = function() {
		setTimeout(function() { 
			//if($('#ftco-loader').length > 0) {
				$('#ftco-loader').removeClass('show');
			//}
		}, 1);
	};
	loader();

var contentWayPoint = function() {
  var i = 0;
  $('.ftco-animate').waypoint( function( direction ) {

    if( direction === 'down' && !$(this.element).hasClass('ftco-animated') ) {
      
      i++;

      $(this.element).addClass('item-animate');
      setTimeout(function(){

        $('body .ftco-animate.item-animate').each(function(k){
          var el = $(this);
          setTimeout( function () {
            var effect = el.data('animate-effect');
            if ( effect === 'fadeIn') {
              el.addClass('fadeIn ftco-animated');
            } else if ( effect === 'fadeInLeft') {
              el.addClass('fadeInLeft ftco-animated');
            } else if ( effect === 'fadeInRight') {
              el.addClass('fadeInRight ftco-animated');
            } else {
              el.addClass('fadeInUp ftco-animated');
            }
            el.removeClass('item-animate');
          },  k * 50, 'easeInOutExpo' );
        });
        
      }, 100);
      
    }

  } , { offset: '95%' } );
};
contentWayPoint();

$('[data-toggle="tooltip"]').tooltip()

$("#nextpage").on("click",function(e){
  let limit=$(this).attr("data-limit");
  let total=$(this).attr("data-total");
  var page=$(this).attr("data-page");
  var loaded=$(this).attr("data-load");
  let module=$(this).attr("data-module");
  let url=$(this).attr("data-url");
  let last=limit*page;
  if(total > last){
    let data={limit:limit,total:total,page:page,loaded:loaded,last:last,module:module};
    $.post(url, data,
      function (res, textStatus, jqXHR) {
        if(res.hasil==1){
          if(res.jumdata>0){
            page=parseInt(page) +1;
            loaded=parseInt(loaded)+res.jumdata;
            if(loaded>=total)  $("#nextpage").html("End of "+module);
            $("#nextpage").attr("data-page",page);
            $("#nextpage").attr("data-load",loaded);
            $("#content_page").append(res.output).fadeIn();
          }
          else {
            $("#nextpage").html("End of "+module);
          }
        }
        else console.log(res);
      },
      "json"
    );
  } else {
    $(this).html("End of "+module);
    //$(this).hide();
  }
});

$(document.body).on("click","#likes",function (e) { 
  e.preventDefault();
  var module=$(this).attr("data-module");
  var id=$(this).attr("data-id");
  var data={module:module,id:id};
  var obj=$(this);
  $.post("syxapi/likes", data,
    function (res, textStatus, jqXHR) {
      if(res.hasil==1){
      }
      obj.html("<i class='fa fa-thumbs-up'></i> "+res.total);
      $("#syxModal").find(".modal-body").html(res.message);
      $("#syxModal").modal("show");
    },
    "json"
  );
});

function setCookie(cname, cvalue, exhours) {
  var d = new Date();
  d.setTime(d.getTime() + (1 * exhours * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var popup_info=function(){
  var popup=getCookie('popup');
  console.log('isi popup= '+popup);
  if(popup!=''){

    let info ='<video autoplay loop><source src="pesan_berkerumun2.mp4" type="video/mp4" /><source src="pesan_berkerumun.webm" type="video/webm" /></video>';
    
    $("#syxModal").find(".modal-body").html(info);
    $("#syxModal").modal("show");
      const modal = document.querySelector("#syxModal");
      const video = modal.querySelector("video");
    video.play();
    $("#syxModal").find(".modal-footer>button").on("click",function(){
      console.log("video pause");
      video.pause();
    });
    $("#syxModal").find(".modal-header>button.close").on("click",function(){
      console.log("video pause");
      video.pause();
    });
    setCookie('popup','sudah',1);
  }
}

$("#gocolaps").on("click",function(e){
  if($("#incolaps").hasClass("d-none")){
    $("#incolaps").removeClass("d-none").addClass("d-block").fadeIn();
  } 
  else{
    $("#incolaps").removeClass("d-block").addClass("d-none").fadeOut();
  }
});

$("form#syxsubmit").submit(function (e) { 
  e.preventDefault();
  let data=$(this).serialize();
  let module=$(this).attr("data-module");
  let type=$(this).attr("data-type");
  $('#ftco-loader').addClass('show');
  $.post("syxapi/submit/"+type+"/"+module, data,
    function (res, textStatus, jqXHR) {
      $('#ftco-loader').removeClass('show');
      $("#syxModal").find(".modal-body").html(res.message);
      $("#syxModal").modal("show");
      if(res.hasil && type=='comments'){
        $("#incolaps").removeClass("d-block").addClass("d-none").fadeOut();
        $("h3#counter").html(res.counter);
        $("ul.comment-list").prepend(res.newdata);
      } 
      else {
        $('#syxModal').on('hidden.bs.modal', function (e) {
          if(typeof(res.backurl)!=='undefined'){
            if(res.backurl!=='norefresh')
            window.location.href=res.backurl;
          } else {
            window.location.href='/home';
          }
        });
      }
    },
    "json"
  );
});

	// magnific popup
	$('.image-popup').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: false,
    fixedContentPos: true,
    mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
     gallery: {
      navigateByImgClick: true,
      enabled: true,
      preload: [0,1] // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      verticalFit: true
    },
    zoom: {
      enabled: true,
      duration: 300 // don't foget to change the duration also in CSS
    }
  });
  
  var pupimg=function(){
  $('.img').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: false,
    image: {
      verticalFit: true
    }
  });
}
  
pupimg();
popup_info();

  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,

    fixedContentPos: false
  });